$ = require 'jquery'
{ ActionHistory } = require '@trello/action-history'
Auth = require 'app/scripts/db/auth'
Card = require 'app/scripts/models/card'
{ getFeedback } = require 'app/scripts/views/suggestions-feedback/get-feedback'
{ getKey, Key } = require '@trello/keybindings'
Label = require 'app/scripts/models/label'
LabelCreateView = require 'app/scripts/views/label/label-create-view'
LabelEditView = require 'app/scripts/views/label/label-edit-view'
LabelKeyHelper = require 'app/scripts/views/label/label-key-helper'
PopOver = require 'app/scripts/views/lib/pop-over'
{ Storage } = require '@trello/storage'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track, trackDebounced } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'

MAX_SUGGESTIONS = 5

module.exports = class LabelsView extends View
  PAGE_SIZE = 12

  labelsToShow: PAGE_SIZE

  events:
    'click .js-select-label': 'clickLabel'
    'click .js-toggle-color-blind-mode': 'toggleColorBlindMode'
    'click .js-edit-label': 'clickEditLabel'
    'click .js-add-label': 'clickAddLabel'
    'click .js-show-more': 'showMore'
    'click .js-suggested-actions-feedback': getFeedback('Labels Select')
    'input .js-label-search': 'renderLabels'
    'keyup .js-label-search': 'keyUp'
    'mouseover .card-label': 'hoverLabel'

  initialize: ({
      @selectLabel
      @board
      @modelCache
      @renderOn
      @popOverMethod
      @searchInit
      }) ->
    @makeDebouncedMethods 'render', 'renderLabels'

    @listenTo Auth.me(),
      'change:prefs': @renderDebounced
    @listenTo @board.labelList,
      'add remove reset change': @renderLabelsDebounced

    for spec in (@renderOn ? [])
      @listenTo spec.source, spec.events, @renderLabelsDebounced

    @_keepVisible = {}
    super

  render: ->
    labelColors = @board.labelColors()
    permsData = { editable: @board.editable() }
    data =
      colors: labelColors
      isColorBlindEnabled:
        Auth.isLoggedIn() && Auth.me().get('prefs').colorBlind
      searchInit: @searchInit ? ''
    @searchInit = null
    @$el.html(templates.fill('popover_change_labels', data, permsData))
    @renderLabels()

  renderLabels: ->
    labelsForColors = @board.labelsForColors()
    filteredLabels = @_filteredLabels()
    allLabels = _.map filteredLabels, (label) =>
      @model.dataForLabel(label)

    # Ideally we'll show @labelsToShow labels, but we want
    # to make sure all of the enabled labels are visible,
    # and labels that were initially visible stay visible
    shouldShow = (label) =>
      label.isActive || @_keepVisible[label.id]

    labels =
      if allLabels.length > @labelsToShow
        enabledLabels = allLabels.filter(shouldShow)
        # How many non-enabled labels do we have space for?
        remaining = @labelsToShow - enabledLabels.length
        _.chain(allLabels)
        .filter (label) =>
          shouldShow(label) || (remaining-- > 0)
        .first(@labelsToShow)
        .value()
      else
        allLabels

    @$('.js-show-more')
      .toggleClass('hide', labels.length == allLabels.length)

    data = { labels }
    permsData = { editable: @board.editable() }

    @$('.js-labels-list')
      .empty()
      .append(templates.fill('select_labels', data, permsData ))

    search = @_searchVal()
    text = if _.isEmpty(search) || filteredLabels.length > 0
      l('create new label.unnamed')
    else
      l('create new label.named', { name: search }, { raw: true })
    @$('.js-add-label').text text

    if !_.isEmpty(search) && filteredLabels.length > 0
      @selectFirstLabelInList()

    showSuggestions =
      !@_searchVal() &&
      # This is also used on CardComposer
      @model instanceof Card &&
      labels.length < allLabels.length

    suggestedLabels =
      if showSuggestions
        @getSuggestedLabels()
      else
        []

    @$('.js-suggestions').toggleClass('hide', suggestedLabels.length == 0)

    @$('.js-suggested-labels-list')
      .empty()
      .append(templates.fill('select_labels', { labels: suggestedLabels }, permsData))

    if suggestedLabels.length > 0
      trackDebounced.hour("Suggestions", "Card Labels Menu", "Displayed", suggestedLabels.length)

    @

  getSuggestedLabels: ->
    history = ActionHistory.get()

    board = @model.getBoard()
    idList = @model.get('idList')

    suggested = new Set()

    history.filter ({ action, context }) ->
      action.type == 'add-label' &&
      context.idList == idList
    .filter ({ action }) ->
      if suggested.has(action.idLabel)
        false
      else
        suggested.add(action.idLabel)
        true
    .filter ({ action }) => @model.isValidSuggestion(action, true)
    .map ({ action }) =>
      label = board.labelList.get(action.idLabel)
      @model.dataForLabel(label)
    .slice(0, MAX_SUGGESTIONS)

  highlightElement: ($elem) ->
    Util.selectMenuItem(@$('.js-labels-list,.js-suggested-labels-list'), '.card-label', $elem)

  getHighlightedElement: ->
    @$('.js-labels-list,.js-suggested-labels-list').find('.card-label.selected').first()

  selectFirstLabelInList: (e) ->
    @highlightElement @$('.js-labels-list,.js-suggested-labels-list').find('.card-label').first()
    return

  toggleColorBlindMode: (e) ->
    me = Auth.me()
    me.toggleColorBlindMode()
    track(@model.typeName, "Labels Menu", "Toggle Color Blind Friendly Mode.")
    return

  clickEditLabel: (e) ->
    Util.stop(e)
    $label = $(e.target).closest('.js-edit-label')
    idLabel = $label.attr('data-idLabel')
    @editLabel(idLabel)

  selectLabelViaElem: ($elem) ->
    idLabel = $elem.attr('data-idLabel')
    fromSuggestion = $elem.closest('.js-suggestions').length > 0

    # If we've interacted with this label, we want to keep it around
    # even if we're hiding some of the other labels
    @_keepVisible[idLabel] = true
    @selectLabel idLabel, fromSuggestion

  clickLabel: (e) ->
    Util.stop(e)
    $label = $(e.target).closest('.js-select-label')
    @selectLabelViaElem($label)

  findElementForLabel: (idLabel) ->
    @$('.js-edit-label').filter (i, el) =>
      $(el).attr('data-idLabel') == idLabel

  editLabel: (idLabel) ->
    $target = @findElementForLabel(idLabel)
    label = @modelCache.get('Label', idLabel)

    PopOver[@popOverMethod]
      elem: $target
      view: LabelEditView
      options:
        model: label
        board: @board
        modelCache: @modelCache

  clickAddLabel: (e) ->
    Util.stop(e)
    search = @_searchVal()
    PopOver[@popOverMethod]
      elem: @$('.js-add-label')
      view: LabelCreateView
      options:
        board: @board
        name: search
        color: @_nextColor()
        onSubmit: (name, color) =>
          @model.createLabel(name, color)
          @clearSearch()
    return

  showMore: ->
    @labelsToShow += PAGE_SIZE
    @renderLabels()

  hoverLabel: (e) ->
    @highlightElement $(e.target).closest('.card-label')
    return

  keyUp: (e) ->
    key = getKey(e)

    if key in [Key.ArrowUp, Key.ArrowDown]
      Util.stop(e)
      Util.navMenuList(@$('.js-labels-list,.js-suggested-labels-list'), '.card-label', key)
      return

    if key != Key.Enter
      return

    labels = @_filteredLabels()

    if labels.length > 0
      $highlightedElement = @getHighlightedElement()
      if $highlightedElement.length > 0
        @selectLabelViaElem $highlightedElement
        @clearSearch()
      track(@model.typeName, "Labels Menu", "Add By Filter")
    else
      @clickAddLabel()

  clearSearch: ->
    @$('.js-label-search').val('')
    @renderLabels()

  _nextColor: ->
    used = _.chain(@board.getLabels())
      .map (label) -> label.get('color')
      .uniq()
      .value()
    _.difference(Label.colors, used)[0] ? ""

  _searchVal: ->
    # Existential on 'val()' so we don't get an err with the old UI
    @$('.js-label-search').val()?.trim() ? ""

  _filteredLabels: ->
    search = @_searchVal().toLowerCase()
    _.chain(@board.getLabels())
      .filter (label) ->
        _.isEmpty(search) ||
          label.get('name')?.toLowerCase().indexOf(search) > -1 ||
          label.get('color')?.toLowerCase().indexOf(search) == 0 ||
          label.get('color') == LabelKeyHelper.keyboardIndex[parseInt(search)]
      .value()
